<template>
	<div id="app">
		<div class="full-width full-height">
			<Header
				class="full-width"
				:style="{ height: header_height + 'px' }"
				:header_height="header_height"
			/>
			<div id="app-content">
				<!--<LeftPanel
					id="left-panel"
					class="left animation relative overflow-y-scroll"
				/>-->
				<div class="full-width full-height active-page">
					<div
						v-if="is_page_active()"
						id="dynamic-page"
						class="overflow-y-scroll primary-bg"
					>
						<div>
							<router-view id="active-page"></router-view>
						</div>
					</div>
					<router-view v-else></router-view>
				</div>

				<div class="clear"></div>
			</div>
			<Footer id="footer" />
		</div>
	</div>
</template>

<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import "@/assets/general.css";
import "@/assets/style.css";
const page_components = ["locations", "portfolio", "faq", "contact"];

export default {
	name: "App",
	components: {
		Header,
		Footer
	},
	data: function() {
		return {
			header_height: 60
		};
	},
	methods: {
		is_page_active: function() {
			if (page_components.indexOf(this.$route.name) != -1) return true;
			var parent = false;
			page_components.forEach(parent_name => {
				this.$route.matched.forEach(matched => {
					if (matched.name == parent_name) {
						parent = true;
					}
				});
			});
			return parent;
		}
	},
	created: function() {
		this.$store.commit("check_locations");
	}
};
</script>

<style>
@import "assets/fonts/app-icon-font.css";
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700,800,900&display=swap");

html,
body,
#app,
#app {
	height: 100%;
	width: 100%;
	min-width: 1200px;
	margin: 0;
}
#app {
	font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}

#nav {
	padding: 30px;
}

#nav a {
	font-weight: bold;
	color: #2c3e50;
}

#nav a.router-link-exact-active {
	color: #42b983;
}

:root {
	--header-height: 60px;
	--footer-height: 60px;
}

#app-content {
	height: calc(100% - var(--header-height) - var(--footer-height));
}

#left-panel {
	padding: 20px 25px;
	width: 350px;
	top: 0;
	height: calc(100% - 40px);
	background-color: #2d2b4b;
	color: white;
}
.active-page > div {
	width: 100%;
	height: 100%;
}
#dynamic-page > div {
	padding: 25px 30px;
}
#active-page-header {
	text-align: right;
	color: #dfe3ea;
	width: 100%;
	height: 60px;
	border-bottom: 1px solid #979797;
	font-size: 28px;
	letter-spacing: 0.54px;
}
#active-page-header p {
	margin: 0;
	padding-right: 35px;
	line-height: 60px;
}
#active-page-content {
	padding: 0 10px;
	height: calc(100% - 50px);
	width: calc(100% - 20px);
}
#close-page {
	position: absolute;
	right: 35px;
	z-index: 9999;
	top: 25px;
}
#active-page {
	padding-top: 30px;
	width: 100%;
	height: calc(100% - 30px);
}
#footer {
	height: var(--footer-height);
	width: 100%;
}
</style>
